import { request } from "../../utils/config"

export const UPDATE_CURRENCY_RATE = async (data) => {
  const response = await request({
    url: `Helpers/MainUSDvsUZS?uzs=${data.uzs}`,
    method: "POST",
    // data: data,
    headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
